/**
 * APIs related to data access (for preview)
 * @module
 */

var Logger = require('core/utils/logger');
var WindowEnv = require('core/env/window');

var NAMESPACE = 'optimizelyDataApi';

/**
 * Register function under the data api namespace
 * @param {string} name Name to register function under
 * @param {function} functionToRegister
 */
exports.registerFunction = function (name:string, functionToRegister:Function) {
  var api = WindowEnv.getGlobal(NAMESPACE);
  if (!api) {
    api = {} as any;
    WindowEnv.setGlobal(NAMESPACE, api);
  }
  if (!api[name]) {
    api[name] = functionToRegister;
  }
};

exports.unregisterFunction = function(name) {
  var api = WindowEnv.getGlobal(NAMESPACE);
  if (api && api[name]) {
    api[name] = function() {
      Logger.log('Ignoring attempt to call "' + NAMESPACE + '.' + name + '" which has been unregistered.');
    };
  }
};

exports.getFunction = function (name) {
  return WindowEnv.getGlobal(NAMESPACE)[name];
};
